// External libraries
import React from 'react';
import { useStoreState } from '@/store';
// @ts-expect-error untyped-import
import { FloatingLabelSelect } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { ALLOWED_GENDERS } from './constants';
import { useMountLogging } from '@/lib/reactHooks';

export type GenderProps = {
  blurHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  focusHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

const Gender = (props: GenderProps): JSX.Element => {
  useMountLogging('Gender');
  const gender = useStoreState(({ form }) => form.gender);
  const genderOptions = ALLOWED_GENDERS.map(gender => ({
    text: getContent(`fieldValues.${gender}`),
    value: gender,
  }));

  return (
    <FloatingLabelSelect
      emptyOption={{ enabled: true }}
      id="gender"
      label={getContent('fieldLabels.gender')}
      name="gender"
      required={true}
      selectOptions={genderOptions}
      {...gender}
      {...props}
    />
  );
};

export { Gender };
